import { render, staticRenderFns } from "./ElemPage.vue?vue&type=template&id=323d7f44&"
import script from "./ElemPage.vue?vue&type=script&lang=js&"
export * from "./ElemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports